import { Box, BoxProps, Flex } from '@chakra-ui/react';
import Ads from '../../components/Ads';
import DashBoardLayout from '../../components/dashboard-layout';
import React from 'react';
const layout = ({
  children
}: BoxProps) => {
  return <DashBoardLayout data-sentry-element="DashBoardLayout" data-sentry-component="layout" data-sentry-source-file="layout.tsx">
      <Flex data-sentry-element="Flex" data-sentry-source-file="layout.tsx">
        <Box w={{
        base: '100%',
        lg: '70%'
      }} pt={8} pb={74} px={{
        base: 4,
        lg: 12
      }} data-sentry-element="Box" data-sentry-source-file="layout.tsx">
          {children}
        </Box>
        <Box pos="fixed" width={{
        lg: '25%'
      }} right={0} data-sentry-element="Box" data-sentry-source-file="layout.tsx">
          <Box pos="absolute" right={0} display={{
          base: 'none',
          lg: 'block'
        }} data-sentry-element="Box" data-sentry-source-file="layout.tsx">
            <Ads bg={process.env.NEXT_PUBLIC_PARTNER_CODE === 'MTNNG' ? '#ffcb05' : '#DFF7FF'} w="100%" maxWidth="500px" height="100vh" data-sentry-element="Ads" data-sentry-source-file="layout.tsx" />
            {/* rgb(253,203,9) rgb(255, 220, 87) */}
          </Box>
        </Box>
      </Flex>
    </DashBoardLayout>;
};
export default layout;